import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import {
  useTheme,
  Grid,
  Stack,
  Dialog,
  DialogContent,
  Typography,
  TextField,
  } from "@mui/material";
import { tokens } from "../theme";
import CustomButton from "./CustomButton";

import dayjs, {  } from "dayjs";
import FancyRadioButtonGroup from "./FancyRadioButtonGroup";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export const DownloadFileWithDatePickerSelectionDialog = ({
  open,
  handleClose,
  handleSubmit,
  type,
  title,
  resetIndex
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const today = dayjs();
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedFile, setSelectedFile] = useState(null);
  const [comment, setComment] = useState("");

  const [datePickerVisibility, setDatePickerVisibility] = useState(false);
  const [fileChooseVisibility, setFileChooseOptionVisibility] = useState(false);

  const [selectedFileTypeValue, setSelectedFileTypeValue] = useState("XLS");

  const handleFileTypeSelectionChange = (event) => {
    setSelectedFileTypeValue(event.target.value);
  };

  const availableFileTypeOptions = [
    { value: "XLS", label: "XLSX" },
    { value: "PDF", label: "PDF" },
    { value: "CSV", label: "CSV" },
  ];

  useEffect(() => {
    setStartDate(null)
    setEndDate(null)
  }, []);

  useEffect(() => {
    if(resetIndex=== 0)
    setStartDate(null)
    setEndDate(null)
  }, [resetIndex]);

  



  const onSubmit = () => {
    // if( selectedFileTypeValue===""){
    //     alert("Please choose a download file format!")
    // } else {
   // const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");

    const startDateValue = dayjs(startDate);
    const endDateValue = dayjs(endDate);
    
    if(!startDateValue.isValid()){
      alert("Please choose start date")
    }else if(!endDateValue.isValid()){
      alert("Please choose End date")
    }
   else if(startDateValue.isAfter(endDateValue)){
       alert("Start date should be less than End date")
    }
    // else if(startDateValue.isSame(endDateValue)){
    //   alert("Start date  & End date should not be same")

    // }
    else if(selectedFileTypeValue===null || selectedFileTypeValue===""){
      alert("Please choose download File Format!")
    
    }else{

      const formatStartDate = startDateValue.format('DD/MM/YYYY')
      const formatEndDate = endDateValue.format('DD/MM/YYYY')

      handleSubmit(selectedFileTypeValue,  type, formatStartDate,formatEndDate);
      setSelectedFileTypeValue("");
      setSelectedDate(today);
      handleClose();
    }

  };

  useEffect(() => {
    switch (type) {
      case "Download":
        setDatePickerVisibility(true);
        setFileChooseOptionVisibility(true);
        break;

      default:
        setDatePickerVisibility(false);
        setFileChooseOptionVisibility(true);
        break;
    }
  }, [type]);

  const handleStartDateChange = (newValue) => {
    setStartDate(newValue);
    if (newValue > endDate) {
      setEndDate(null);
    }
  };

  const handleEndDateChange = (newValue) => {
    if (!startDate || newValue >= startDate) {
      setEndDate(newValue);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          background: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <DialogContent
        sx={{
          background: "white",
          borderRadius: "12px",
          overflow: "initial",
          marginBottom: "15px",
        }}
      >
        <Grid
          container
          direction={"column"}
          alignItems={"center"}
          alignContent={"center"}
          justifyItems={"center"}
          justifyContent={"center"}
        >
          <Grid container xs={10}>
            <Grid container justifyContent={"center"}>
              <Typography fontWeight={"600"} variant="h3" p={1}>
                {title}
              </Typography>
            </Grid>

            <Grid container>
              {/*** Date Picker ***/}
              {/* {datePickerVisibility && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <StaticDatePicker
                    //defaultValue={setTodaysDate}
                    label="Choose Date"
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    maxDate={today}
                    //minDate={today}
                    orientation="landscape"
                    ToolbarComponent={() => <></>} // Hides the toolbar, including the 'Cancel' and 'OK' buttons
                    sx={{
                      marginTop: "3px",
                      "& .MuiDialogActions-root": {
                        // Targets the actions bar containing 'Cancel' and 'OK' buttons
                        display: "none",
                      },
                    }}
                  />
                </LocalizationProvider>
              )} */}

              {datePickerVisibility && (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Box
                  mt={5}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <DatePicker
                      label="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <DatePicker
                      label="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Box>
                </LocalizationProvider>
              )}

              
              <Grid container justifyContent={"flex-start"} mt={3} pb={2}>
                {/**** Attach File ***/}
                {fileChooseVisibility && (
                  <>
                    <label>File Format</label>

                    <label
                      htmlFor="file-upload"
                      style={{
                        border: "1px solid #94B0E0",
                        borderRadius: "64px",
                        width: "100%",
                        textAlign: "center",
                        margin: "15px auto",
                        fontSize: "12px",
                        fontWeight: "700",
                        letterSpacing: "1.25px",
                        padding: "6px 24px",
                        textTransform: "uppercase",
                        cursor: "pointer",
                      }}
                    >
                      <FancyRadioButtonGroup
                        label=""
                        value={selectedFileTypeValue}
                        onChange={handleFileTypeSelectionChange}
                        options={availableFileTypeOptions}
                      />
                    </label>
                  </>
                )}

                <Grid container justifyContent={"flex-end"}>
                  <Stack
                    direction="row"
                    pt={2}
                    spacing={2}
                    justifyContent={"center"}
                  >
                    <CustomButton
                      btnBG={colors.primary[900]}
                      btnColor={colors.grey[100]}
                      btnTxt={"Cancel"}
                      btnBorder={"1px solid" + colors.primary[800]}
                      onClick={handleClose}
                    ></CustomButton>

                    <CustomButton
                      btnBG={colors.primary[100]}
                      btnColor={colors.grey[900]}
                      btnTxt={"Download"}
                      btnBorder={"1px solid" + colors.primary[100]}
                      onClick={onSubmit}
                    ></CustomButton>

                    {/* 
                    <Button onClick={} color="secondary">
                    Cancel
                  </Button>
                  <Button onClick={onSubmit} color="primary">
                    Submit
                  </Button> */}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      {/* <DialogActions> */}

      {/* </DialogActions> */}
    </Dialog>

    
  );
};
